import router from "@/router/index";
import {setToken} from "@/utils/auth";
import LayoutTLR from '@/views/layout_tlr/Index.vue'

const getLayout = ()=>{return LayoutTLR;}

export default {
  state: {
    rows:[],
  },
  mutations:{
    saveMenu(state,ds){
      state.rows = ds;
    }
  },
  actions: {
    initMenu({commit,state},res){
      return new Promise((resolve,rej)=>{
        commit('saveMenu',res.menus);
        res.menus.forEach(r=>{
          let exists = false;
          const param = r.pageFile;
          router.getRoutes().forEach(n=>{if(n.path==r.url) exists=true;})
          if(!exists) router.addRoute({ path: r.url, component:getLayout(),children:[{path:'',name: r.resourceName + Math.random(), component:resolve => require([`@/views/${param}`], resolve)}] })
        });
        localStorage.setItem("vue_store_menu",JSON.stringify(res.menus));
        resolve(true);
      });
    },
    reloadMenu({commit,state}){
      let res = localStorage.getItem('vue_store_menu');
      if(res==null)return;
      res = JSON.parse(res);
      res.forEach(r=>{
        let exists = false;
        const param = r.pageFile;
        router.getRoutes().forEach(n=>{if(n.path==r.url) exists=true;})
        if(!exists) router.addRoute({ path: r.url, component:getLayout(),children:[{path:'',name: r.resourceName + Math.random(), component:resolve => require([`@/views/${param}`], resolve)}] })
      });
      commit('saveMenu',res);
    },
    out(state){
      console.log(state.state)
    },
  },
  getters: {
    // app: state => {
    //   return state.app;
    // },
    // menu.css: state=>{
    //   return state.menu.css;
    // }
  }
};
